import {call} from "wasm-imagemagick";

import {base64ToBuffer, blobToDataURL} from "./common";

export const updateWithMagick = (dataUrl,
                                 command=["convert", "eyespy360.png", '-auto-gamma', '-sigmoidal-contrast', '3,30%', '-channel', 'RGB', 'out3.png'],
                                 type='base64,') => {
    return new Promise(async (res, rej) => {
        try{
            const image = { name: 'eyespy360.png', content: base64ToBuffer(dataUrl.split(type)[1])};
            const result = await call([image], command);

            if(result.exitCode !== 0) {
                return alert('There was an error: ' + result.stderr.join('\n'));
            }

            dataUrl = await blobToDataURL(result.outputFiles[0].blob);
            res(dataUrl);
        }catch (e) {
            rej(e);
        }
    })
}
